import { filter, tap } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "./license.service";
import * as i2 from "@angular/router";
var LicenseGuard = /** @class */ (function () {
    function LicenseGuard(licenseService, router) {
        this.licenseService = licenseService;
        this.router = router;
    }
    LicenseGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        return this.licenseService.licenseValidatedObs().pipe(filter(function (valid) { return valid !== undefined; }), tap(function (valid) {
            if (!valid) {
                _this.router.navigate(['/licensenotfound']);
            }
        }));
    };
    LicenseGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LicenseGuard_Factory() { return new LicenseGuard(i0.ɵɵinject(i1.LicenseService), i0.ɵɵinject(i2.Router)); }, token: LicenseGuard, providedIn: "root" });
    return LicenseGuard;
}());
export { LicenseGuard };
